<div
  #overlay
  class="fixed inset-0 z-[9999]"
  [class.pointer-events-none]="!tour.isActive()"
  [class.pointer-events-auto]="tour.isActive()"
>
  @if (tour.isActive()) {
    <div class="fixed inset-0 bg-transparent"></div>

    <div
      class="fixed rounded-[16px] pointer-events-none shadow-[0_0_0_9999px_rgba(7,12,20,0.78)] transition-[top,left,width,height] duration-[250ms] ease-out"
      [ngStyle]="spotlightDimStyle()"
    ></div>

    <div
      class="fixed rounded-[12px] pointer-events-none outline outline-2 outline-offset-0 outline-[#4ce364] transition-[top,left,width,height] duration-[250ms] ease-out"
      [ngStyle]="spotlightRingStyle()"
    ></div>

    @let step = tour.currentStep();
    @if (step) {
      <div
        class="fixed w-[280px] max-w-[calc(100vw_-_24px)] p-4 rounded-[14px] bg-[#16202f] border border-[#212e41] text-white font-Satoshi shadow-[0_12px_32px_rgba(0,0,0,0.45)]"
        [ngStyle]="tooltipStyle()"
      >
        <button
          type="button"
          class="absolute top-3 right-[14px] p-0 bg-transparent border-0 text-[12px] font-medium text-[#697e9d] cursor-pointer"
          (click)="skip()"
          aria-label="Pular tour"
        >Pular</button>

        @if (step.title) {
          <h3 class="m-0 mb-[6px] pr-10 text-[16px] font-bold leading-[22px]">{{ step.title }}</h3>
        }
        <p class="m-0 text-[13px] leading-[19px] text-[#b9c4d4]">{{ step.content }}</p>

        <div class="flex items-center justify-between mt-[18px]">
          <span class="text-[12px] font-medium text-[#697e9d]">{{ tour.currentIndex() + 1 }}/{{ tour.total() }}</span>

          <div class="flex gap-2">
            @if (!tour.isFirst()) {
              <button
                type="button"
                class="py-2 px-4 rounded-lg border border-[#212e41] bg-transparent text-[#b9c4d4] text-[13px] font-bold cursor-pointer transition-opacity duration-200 hover:opacity-90"
                (click)="previous()"
              >Voltar</button>
            }
            <button
              type="button"
              class="py-2 px-4 rounded-lg border-0 bg-[#4ce364] text-[#0b1118] text-[13px] font-bold cursor-pointer transition-opacity duration-200 hover:opacity-90"
              (click)="next()"
            >{{ tour.isLast() ? 'Entendi' : 'Próximo' }}</button>
          </div>
        </div>
      </div>
    }
  }
</div>
